import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EditorialPreview from "./EditorialPreview";
import "./Editorial.css";
import API_URL from "../../../../apiConfig";
import AdminHeader from "../../../../components/AdminHeader";
import MediaPicker from "../../../../components/admin/MediaPicker";

const EMPTY_FORM = {
  slug: "",
  slug_fr: "",
  issue_line: "",
  issue_line_fr: "",
  hero_title: "",
  hero_title_fr: "",
  hero_sub: "",
  hero_sub_fr: "",
  lead: "",
  lead_fr: "",
  idea_central: "",
  idea_central_fr: "",
  practica: "",
  practica_fr: "",
  bloque1_title: "",
  bloque1_title_fr: "",
  bloque1_p1: "",
  bloque1_p1_fr: "",
  quote_text: "",
  quote_text_fr: "",
  bloque1_p2: "",
  bloque1_p2_fr: "",
  callout_title: "",
  callout_title_fr: "",
  step1: "",
  step1_fr: "",
  step2: "",
  step2_fr: "",
  step3: "",
  step3_fr: "",
  step4: "",
  step4_fr: "",
  callout_text: "",
  callout_text_fr: "",
  cierre_title: "",
  cierre_title_fr: "",
  cierre_text: "",
  cierre_text_fr: "",
  hero_image: "",
  inline_image: "",
  inline_caption: "",
  inline_caption_fr: "",
  callout_body: "",
  callout_body_fr: "",
  meta_title_fr: "",
  meta_description_fr: "",
  type: "newsletter",
};

const EDITORIAL_STEPS = [
  {
    id: "identidad",
    label: "Identidad",
    helper: "Define el formato, la URL y la línea editorial en español y francés.",
  },
  {
    id: "portada",
    label: "Portada",
    helper: "Crea título, subtítulo e imagen inicial. Escribe español y francés en el mismo bloque.",
  },
  {
    id: "apertura",
    label: "Apertura",
    helper: "Abre la edición con contexto, tono y dirección editorial en ambos idiomas.",
  },
  {
    id: "idea",
    label: "Idea central",
    helper: "Escribe el principio que sostiene toda la edición en español y francés.",
  },
  {
    id: "desarrollo",
    label: "Desarrollo editorial",
    helper:
      "Construye profundidad con un bloque principal y ángulos opcionales de la misma idea.",
  },
  {
    id: "notas",
    label: "Notas de ZEDRO",
    helper: "Agrega una nota breve de marca en ambos idiomas solo si aporta claridad.",
  },
  {
    id: "cierre",
    label: "Cierre",
    helper: "Cierra con sobriedad, dirección y una última idea clara.",
  },
  {
    id: "cta",
    label: "CTA",
    helper: "Define una sola acción clara, sin presión y coherente con la edición.",
  },
  {
    id: "revision",
    label: "Revisión",
    helper: "Revisa la edición completa antes de publicar o enviar.",
  },
];


const MOBILE_EDITORIAL_STYLES = `
  @media (max-width: 900px) {
    .admNlEdit {
      padding: 18px 14px 44px !important;
      overflow-x: hidden !important;
      box-sizing: border-box !important;
    }

    .admNl-header {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 14px !important;
      align-items: start !important;
      margin-bottom: 16px !important;
    }

    .admNlHeader-left,
    .admNlHeader-actions {
      width: 100% !important;
      min-width: 0 !important;
    }

    .admNl-header h1 {
      font-size: 27px !important;
      line-height: 1.08 !important;
      letter-spacing: -0.04em !important;
    }

    .admNlHeader-sub {
      display: grid !important;
      gap: 8px !important;
      align-items: start !important;
    }

    .admNlHeader-actions {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 10px !important;
    }

    .admNlHeader-actions .admNl-btn {
      width: 100% !important;
      min-height: 44px !important;
      justify-content: center !important;
    }

    .admNlEdit-grid.flagship {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 16px !important;
      width: 100% !important;
      min-width: 0 !important;
    }

    .admNlEdit-form.flagship,
    .admNlEdit-preview.flagship {
      width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
    }

    .admNlStepNavigation {
      padding: 13px !important;
      border-radius: 18px !important;
    }

    .admNlStepButtons {
      display: flex !important;
      flex-wrap: nowrap !important;
      gap: 8px !important;
      overflow-x: auto !important;
      padding-bottom: 4px !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: thin !important;
    }

    .admNlStepButton {
      flex: 0 0 auto !important;
      white-space: nowrap !important;
      min-height: 40px !important;
    }

    .admNlSection {
      border-radius: 20px !important;
      padding: 18px !important;
      box-sizing: border-box !important;
    }

    .admNlSection-head h2 {
      font-size: 22px !important;
      line-height: 1.12 !important;
    }

    .admNlSection-head p {
      font-size: 13px !important;
      line-height: 1.5 !important;
    }

    .admNlRow.one,
    .admNlRow.two {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 14px !important;
      width: 100% !important;
      min-width: 0 !important;
    }

    .admNlLangHeader {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 8px !important;
    }

    .admNlField {
      min-width: 0 !important;
      width: 100% !important;
    }

    .admNlField input,
    .admNlField textarea,
    .admNlField select {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
      font-size: 16px !important;
    }

    .admNlField textarea {
      min-height: 132px !important;
    }

    .admNl-btn {
      min-height: 44px !important;
      padding-left: 14px !important;
      padding-right: 14px !important;
      border-radius: 12px !important;
    }

    .admNlEdit-preview.flagship {
      position: static !important;
      max-height: none !important;
    }

    .admNlPreviewHeader {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 10px !important;
    }

    .admNlPreviewHeader .admNl-btn {
      width: 100% !important;
      justify-content: center !important;
    }

    .admNlPreviewFrame {
      max-height: 520px !important;
      overflow: auto !important;
      -webkit-overflow-scrolling: touch !important;
    }
  }

  @media (max-width: 430px) {
    .admNlEdit {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .admNlHeader-actions {
      grid-template-columns: 1fr !important;
    }

    .admNlSection {
      padding: 16px !important;
      border-radius: 18px !important;
    }

    .admNl-header h1 {
      font-size: 24px !important;
    }
  }
`;

function slugify(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

function getStatusLabel(status) {
  const value = String(status || "draft").toLowerCase();

  const labels = {
    draft: "Borrador",
    published: "Publicado",
    sent: "Enviado",
    archived: "Archivado",
  };

  return labels[value] || value;
}

function characterCount(value = "") {
  return String(value || "").length;
}

function hasContent(...values) {
  return values.some((value) => String(value || "").trim().length > 0);
}

const LEGACY_EDITORIAL_VALUES = new Set(["VER", "ELEGIR", "ELIMINAR"]);

function cleanLegacyValue(value) {
  const original = value ?? "";
  const trimmed = String(original).trim();

  if (LEGACY_EDITORIAL_VALUES.has(trimmed.toUpperCase())) {
    return "";
  }

  return original;
}

function cleanEditorialForm(data = {}) {
  const safe = Object.keys(EMPTY_FORM).reduce((acc, key) => {
    acc[key] = cleanLegacyValue(data?.[key] ?? EMPTY_FORM[key] ?? "");
    return acc;
  }, {});

  if (data?.status) safe.status = data.status;

  return safe;
}

function FieldCount({ value, ideal }) {
  return (
    <small>
      {ideal} Caracteres actuales: {characterCount(value)}.
    </small>
  );
}

function LanguageHeader() {
  return (
    <div
      className="admNlLangHeader"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 14,
        margin: "2px 0 8px",
      }}
    >
      <div
        style={{
          borderRadius: 14,
          padding: "10px 12px",
          background: "rgba(15,47,70,.06)",
          color: "#0f2f46",
          fontSize: 12,
          fontWeight: 900,
          letterSpacing: ".12em",
          textTransform: "uppercase",
        }}
      >
        Español
      </div>

      <div
        style={{
          borderRadius: 14,
          padding: "10px 12px",
          background: "rgba(207,174,85,.12)",
          color: "#8b6f1e",
          fontSize: 12,
          fontWeight: 900,
          letterSpacing: ".12em",
          textTransform: "uppercase",
        }}
      >
        Français
      </div>
    </div>
  );
}

export default function AdminNewsletterEdit({ mode }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(mode === "edit");
  const [activeStep, setActiveStep] = useState(0);

  const [isDirty, setIsDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const [savedPulse, setSavedPulse] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const initialSnapshot = useRef(JSON.stringify(EMPTY_FORM));

  const title = mode === "new" ? "Nueva edición ZEDRO News" : "Editar ZEDRO News";
  const currentStep = EDITORIAL_STEPS[activeStep];
  const isLastStep = activeStep === EDITORIAL_STEPS.length - 1;

  const setField = (name, value) => {
    setForm((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "issue_line") {
        updated.slug = slugify(value);
      }

      if (name === "issue_line_fr") {
        updated.slug_fr = slugify(value);
      }

      return updated;
    });

    setIsDirty(true);
  };

  const normalizeFromBackend = (data) => cleanEditorialForm(data);

  useEffect(() => {
    const load = async () => {
      try {
        if (mode === "edit" && id) {
          setLoading(true);

          const res = await fetch(
            `${API_URL}/api/editorials/by-id/${id}`
          );

          const json = await res.json();
          const data = json.editorial;
          const safe = normalizeFromBackend(data);

          setForm(safe);
          initialSnapshot.current = JSON.stringify(safe);
          setIsDirty(false);
        } else {
          setForm(EMPTY_FORM);
          initialSnapshot.current = JSON.stringify(EMPTY_FORM);
          setIsDirty(false);
        }
      } catch (e) {
        console.error(e);
        alert("No se pudo cargar la edición.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, mode]);

  useEffect(() => {
    const now = JSON.stringify(form);
    const base = initialSnapshot.current;
    setIsDirty(now !== base);
  }, [form]);

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (!isDirty) return;
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [isDirty]);

  const validationError = useMemo(() => {
    if (!form.issue_line?.trim()) return "La línea de edición es obligatoria.";
    if (!form.hero_title?.trim()) return "El título principal es obligatorio.";
    return "";
  }, [form.issue_line, form.hero_title]);

  const save = async () => {
    try {
      if (validationError) return alert(validationError);

      setSaving(true);

      const method = id ? "PUT" : "POST";

      const url = id
        ? `${API_URL}/api/editorials/${id}`
        : `${API_URL}/api/editorials`;

      const cleanedForm = {
        ...cleanEditorialForm(form),
        type: form.type || "newsletter",
      };

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cleanedForm),
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("ERROR BACKEND:", text);
        throw new Error("Error guardando editorial");
      }

      setForm(cleanedForm);
      initialSnapshot.current = JSON.stringify(cleanedForm);
      setIsDirty(false);
      setSavedPulse(true);
      setTimeout(() => setSavedPulse(false), 900);

      navigate("/admin/produccion/editorial");
    } catch (e) {
      console.error(e);
      alert("Error al guardar. Revisa consola.");
    } finally {
      setSaving(false);
    }
  };

  const goNext = () => {
    setActiveStep((prev) => Math.min(prev + 1, EDITORIAL_STEPS.length - 1));
  };

  const goBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const renderStepNavigation = () => (
    <div
      className="admNlStepNavigation"
      style={{
        display: "grid",
        gap: 10,
        padding: 14,
        borderRadius: 18,
        border: "1px solid rgba(44,59,81,.12)",
        background: "rgba(255,255,255,.78)",
        boxShadow: "0 10px 24px rgba(0,0,0,.04)",
      }}
    >
      <div
        className="admNlStepButtons"
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        {EDITORIAL_STEPS.map((step, index) => {
          const active = index === activeStep;

          return (
            <button
              key={step.id}
              className="admNlStepButton"
              type="button"
              onClick={() => setActiveStep(index)}
              style={{
                border: active
                  ? "1px solid rgba(204,174,73,.58)"
                  : "1px solid rgba(44,59,81,.12)",
                background: active
                  ? "linear-gradient(135deg, #0f2f46 0%, #173f5b 100%)"
                  : "#fff",
                color: active ? "#f4d27a" : "rgba(44,59,81,.74)",
                borderRadius: 999,
                padding: "9px 12px",
                fontSize: 12,
                fontWeight: 800,
                cursor: "pointer",
              }}
            >
              {index + 1}. {step.label}
            </button>
          );
        })}
      </div>

      <div>
        <strong style={{ color: "#0f2f46", fontSize: 14 }}>
          {currentStep.label}
        </strong>
        <p
          style={{
            margin: "5px 0 0",
            fontSize: 12.5,
            color: "rgba(44,59,81,.64)",
            lineHeight: 1.45,
          }}
        >
          {currentStep.helper}
        </p>
      </div>
    </div>
  );

  const renderBilingualInput = ({
    label,
    nameEs,
    nameFr,
    placeholderEs,
    placeholderFr,
    helperEs,
    helperFr,
    readOnly = false,
  }) => (
    <div className="admNlRow two">
      <div className="admNlField">
        <label>{label} · ESPAÑOL</label>
        <input
          name={nameEs}
          value={form[nameEs] || ""}
          onChange={(e) => setField(nameEs, e.target.value)}
          placeholder={placeholderEs}
          autoComplete="off"
          readOnly={readOnly}
          style={readOnly ? { background: "#f5f7fa", cursor: "not-allowed" } : undefined}
        />
        {helperEs && <small>{helperEs}</small>}
      </div>

      <div className="admNlField">
        <label>{label} · FRANÇAIS</label>
        <input
          name={nameFr}
          value={form[nameFr] || ""}
          onChange={(e) => setField(nameFr, e.target.value)}
          placeholder={placeholderFr}
          autoComplete="off"
          readOnly={readOnly}
          style={readOnly ? { background: "#f5f7fa", cursor: "not-allowed" } : undefined}
        />
        {helperFr && <small>{helperFr}</small>}
      </div>
    </div>
  );

  const renderBilingualTextarea = ({
    label,
    nameEs,
    nameFr,
    placeholderEs,
    placeholderFr,
    rows = 4,
    idealEs,
    idealFr,
    helperEs,
    helperFr,
    quote = false,
  }) => (
    <div className="admNlRow two">
      <div className={"admNlField " + (quote ? "quote" : "")}>
        <label>{label} · ESPAÑOL</label>
        <textarea
          name={nameEs}
          value={form[nameEs] || ""}
          onChange={(e) => setField(nameEs, e.target.value)}
          placeholder={placeholderEs}
          rows={rows}
        />
        {idealEs ? (
          <FieldCount value={form[nameEs]} ideal={idealEs} />
        ) : (
          helperEs && <small>{helperEs}</small>
        )}
      </div>

      <div className={"admNlField " + (quote ? "quote" : "")}>
        <label>{label} · FRANÇAIS</label>
        <textarea
          name={nameFr}
          value={form[nameFr] || ""}
          onChange={(e) => setField(nameFr, e.target.value)}
          placeholder={placeholderFr}
          rows={rows}
        />
        {idealFr ? (
          <FieldCount value={form[nameFr]} ideal={idealFr} />
        ) : (
          helperFr && <small>{helperFr}</small>
        )}
      </div>
    </div>
  );

  const renderIdentityStep = () => (
    <div className="admNlSection meta">
      <div className="admNlSection-head">
        <h2>Identidad</h2>
        <p>
          Ficha interna de la edición. Aquí defines el formato, la URL y la
          línea editorial en español y francés.
        </p>
      </div>

      <div className="admNlRow one">
        <div className="admNlField">
          <label>TIPO EDITORIAL</label>
          <select
            value={form.type}
            onChange={(e) => setField("type", e.target.value)}
          >
            <option value="newsletter">Newsletter</option>
            <option value="ebook">E-book</option>
            <option value="workbook">Workbook</option>
            <option value="revista">Revista</option>
          </select>
          <small>
            Para ZEDRO News, usa Newsletter. Los otros formatos pueden servir
            más adelante para productos editoriales.
          </small>
        </div>
      </div>

      <LanguageHeader />

      {renderBilingualInput({
        label: "SLUG / URL",
        nameEs: "slug",
        nameFr: "slug_fr",
        readOnly: true,
        helperEs:
          "Se genera automáticamente desde la línea de edición en español.",
        helperFr:
          "Se genera automáticamente desde la línea de edición en francés. Solo si existe aparecerá en /fr/zedro-news.",
      })}

      {renderBilingualInput({
        label: "LÍNEA DE EDICIÓN",
        nameEs: "issue_line",
        nameFr: "issue_line_fr",
        placeholderEs: "Ej: Edición 0001 · Arquitectura del enfoque",
        placeholderFr: "Ex. Édition 0001 · L’architecture de l’attention",
        helperEs: "Sirve para identificar la edición dentro del archivo editorial.",
        helperFr:
          "Identifica la edición en el archivo francés y crea su URL pública.",
      })}

      <div className="admNlRow one">
        <div className="admNlField">
          <label>ESTADO</label>
          <input
            value={
              mode === "new"
                ? "Borrador"
                : getStatusLabel(form.status || "draft")
            }
            readOnly
          />
          <small>
            Este campo es informativo. La publicación se gestiona desde el
            listado editorial.
          </small>
        </div>
      </div>
    </div>
  );

  const renderCoverStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>Portada bilingüe</h2>
        <p>
          Escribe la portada en español y francés dentro del mismo bloque. La
          imagen es compartida para ambos idiomas.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualTextarea({
        label: "TÍTULO PRINCIPAL",
        nameEs: "hero_title",
        nameFr: "hero_title_fr",
        placeholderEs: "Una frase que defina la transformación que esta edición propone.",
        placeholderFr: "Une phrase qui définit la transformation proposée par cette édition.",
        rows: 2,
        idealEs: "Ideal: 45–90 caracteres. Claro, sobrio y con peso.",
        idealFr: "Idéal : 45–90 caractères. Clair, sobre et professionnel.",
      })}

      {renderBilingualTextarea({
        label: "SUBTÍTULO",
        nameEs: "hero_sub",
        nameFr: "hero_sub_fr",
        placeholderEs: "Complementa el título sin repetirlo. Añade dirección y tono.",
        placeholderFr: "Complète le titre sans le répéter. Ajoute direction et ton.",
        rows: 2,
        idealEs: "Ideal: 90–160 caracteres. Explica la promesa de la edición.",
        idealFr: "Idéal : 90–160 caractères. Explique la promesse de l’édition.",
      })}

      <MediaPicker
        label="IMAGEN DE PORTADA (Compartida)"
        value={form.hero_image}
        onChange={(url) => setField("hero_image", url)}
        helper="Opcional. La misma imagen se usará para español y francés."
      />
    </div>
  );

  const renderOpeningStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>Apertura bilingüe</h2>
        <p>
          La apertura presenta el tema sin cargar la edición. Debe preparar al
          lector para una sola idea central.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualTextarea({
        label: "APERTURA EDITORIAL",
        nameEs: "lead",
        nameFr: "lead_fr",
        placeholderEs: "3–6 líneas. Abre el tema con elegancia, contexto y autoridad.",
        placeholderFr: "3–6 lignes. Ouvre le sujet avec élégance, contexte et direction.",
        rows: 5,
        idealEs: "Ideal: 300–600 caracteres. Abre el tema con claridad, sin hacerlo largo.",
        idealFr: "Idéal : 300–600 caractères. Ouvre le sujet avec clarté, sans l’alourdir.",
      })}
    </div>
  );

  const renderIdeaStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>Idea central bilingüe</h2>
        <p>
          Es el corazón de la edición. Todo lo demás debe profundizar esta idea,
          no abrir temas nuevos.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualTextarea({
        label: "IDEA CENTRAL",
        nameEs: "idea_central",
        nameFr: "idea_central_fr",
        placeholderEs: "Define el principio central en 1–2 párrafos. Una edición = una idea fuerte.",
        placeholderFr: "Définis l’idée centrale en 1–2 paragraphes. Une édition = une idée forte.",
        rows: 6,
        idealEs: "Ideal: 500–900 caracteres. Una idea clara, profunda y aplicable.",
        idealFr: "Idéal : 500–900 caractères. Une idée claire, profonde et applicable.",
      })}
    </div>
  );

  const renderDevelopmentStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>Desarrollo editorial bilingüe</h2>
        <p>
          Desarrolla la misma idea desde un bloque principal y ángulos
          opcionales. Trabaja cada campo en español y su equivalente en francés.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualInput({
        label: "TÍTULO DEL BLOQUE PRINCIPAL",
        nameEs: "bloque1_title",
        nameFr: "bloque1_title_fr",
        placeholderEs: "Ej: El enfoque no se encuentra, se establece",
        placeholderFr: "Ex. L’attention ne se trouve pas, elle s’établit",
        helperEs: "Ideal: 45–90 caracteres.",
        helperFr: "Idéal : 45–90 caractères.",
      })}

      {renderBilingualTextarea({
        label: "BLOQUE PRINCIPAL",
        nameEs: "bloque1_p1",
        nameFr: "bloque1_p1_fr",
        placeholderEs: "Desarrolla la idea con claridad. Sin adornos, con sustancia.",
        placeholderFr: "Développe l’idée avec clarté, sans surcharge, avec substance.",
        rows: 7,
        idealEs: "Ideal: 500–900 caracteres.",
        idealFr: "Idéal : 500–900 caractères.",
      })}

      <MediaPicker
        label="IMAGEN DEL BLOQUE PRINCIPAL (Compartida)"
        value={form.inline_image}
        onChange={(url) => setField("inline_image", url)}
        helper="Opcional. La misma imagen se usará para español y francés."
      />

      {renderBilingualTextarea({
        label: "PIE DE IMAGEN",
        nameEs: "inline_caption",
        nameFr: "inline_caption_fr",
        placeholderEs: "Texto breve que acompaña la imagen.",
        placeholderFr: "Texte bref qui accompagne l’image.",
        rows: 2,
        helperEs: "Opcional. Solo se mostrará si agregaste imagen.",
        helperFr: "Optionnel. S’affiche seulement si une image est ajoutée.",
      })}

      {renderBilingualTextarea({
        label: "FRASE DESTACADA",
        nameEs: "quote_text",
        nameFr: "quote_text_fr",
        placeholderEs: "Una frase corta, contundente, memorable.",
        placeholderFr: "Une phrase courte, sobre et mémorable.",
        rows: 2,
        idealEs: "Opcional. Ideal: 90–160 caracteres.",
        idealFr: "Optionnel. Idéal : 90–160 caractères.",
        quote: true,
      })}

      {renderBilingualTextarea({
        label: "ÁNGULO DE PROFUNDIZACIÓN",
        nameEs: "bloque1_p2",
        nameFr: "bloque1_p2_fr",
        placeholderEs: "Profundiza la misma idea desde otro ángulo. No abras un tema nuevo.",
        placeholderFr: "Approfondis la même idée depuis un autre angle. N’ouvre pas un nouveau thème.",
        rows: 6,
        idealEs: "Opcional. Ideal: 400–800 caracteres.",
        idealFr: "Optionnel. Idéal : 400–800 caractères.",
      })}

      {renderBilingualInput({
        label: "TÍTULO DE BLOQUE ADICIONAL",
        nameEs: "callout_title",
        nameFr: "callout_title_fr",
        placeholderEs: "Ej: Un ángulo para mirar esta idea en la vida diaria",
        placeholderFr: "Ex. Un angle pour regarder cette idée dans la vie quotidienne",
        helperEs: "Opcional. Úsalo solo si necesitas una sección adicional.",
        helperFr: "Optionnel. À utiliser seulement si une section additionnelle est nécessaire.",
      })}

      {renderBilingualTextarea({
        label: "BLOQUE ADICIONAL",
        nameEs: "callout_text",
        nameFr: "callout_text_fr",
        placeholderEs: "Desarrolla un ángulo complementario. Mantén continuidad con la idea central.",
        placeholderFr: "Développe un angle complémentaire. Garde la continuité avec l’idée centrale.",
        rows: 5,
        idealEs: "Opcional. Ideal: 300–700 caracteres.",
        idealFr: "Optionnel. Idéal : 300–700 caractères.",
      })}

      {renderBilingualInput({
        label: "SEGUNDO BLOQUE ADICIONAL · TÍTULO",
        nameEs: "step1",
        nameFr: "step1_fr",
        placeholderEs: "Ej: Una pregunta para llevarlo al corazón",
        placeholderFr: "Ex. Une question pour l’amener au cœur",
        helperEs: "Opcional. Úsalo solo si necesitas separar otro ángulo.",
        helperFr: "Optionnel. À utiliser seulement si un autre angle est nécessaire.",
      })}

      {renderBilingualTextarea({
        label: "SEGUNDO BLOQUE ADICIONAL · TEXTO",
        nameEs: "step2",
        nameFr: "step2_fr",
        placeholderEs: "Texto breve de profundización.",
        placeholderFr: "Texte bref d’approfondissement.",
        rows: 5,
        idealEs: "Opcional. Ideal: 250–600 caracteres.",
        idealFr: "Optionnel. Idéal : 250–600 caractères.",
      })}

      {renderBilingualTextarea({
        label: "LISTA O REFLEXIÓN BREVE",
        nameEs: "step3",
        nameFr: "step3_fr",
        placeholderEs: "Puedes escribir una reflexión breve o una lista separada por saltos de línea.",
        placeholderFr: "Tu peux écrire une courte réflexion ou une liste séparée par des sauts de ligne.",
        rows: 5,
        helperEs:
          "Opcional. Este campo reemplaza los pasos rígidos; úsalo solo si ordena la lectura.",
        helperFr:
          "Optionnel. Ce champ remplace les étapes rigides; utilise-le seulement s’il clarifie la lecture.",
      })}
    </div>
  );

  const renderNotesStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>Notas de ZEDRO bilingüe</h2>
        <p>
          Una nota breve de marca puede aportar cercanía, contexto o una
          precisión editorial. Es opcional.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualTextarea({
        label: "NOTA EDITORIAL DE ZEDRO",
        nameEs: "callout_body",
        nameFr: "callout_body_fr",
        placeholderEs:
          "Ej: En ZEDRO Academy creemos que la formación no comienza con presión, sino con verdad aplicada en lo cotidiano.",
        placeholderFr:
          "Ex. Chez ZEDRO Academy, nous croyons que la formation ne commence pas par la pression, mais par une vérité appliquée au quotidien.",
        rows: 5,
        idealEs: "Opcional. Ideal: 200–500 caracteres.",
        idealFr: "Optionnel. Idéal : 200–500 caractères.",
      })}
    </div>
  );

  const renderClosingStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>Cierre bilingüe</h2>
        <p>
          Una última idea que quede resonando. No debe sonar exagerada; debe
          cerrar con dirección.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualInput({
        label: "TÍTULO DEL CIERRE",
        nameEs: "cierre_title",
        nameFr: "cierre_title_fr",
        placeholderEs: "Ej: Lo que no eliges, te elige",
        placeholderFr: "Ex. Ce que tu ne choisis pas finit par te choisir",
        helperEs: "Opcional. Úsalo solo si el cierre necesita título propio.",
        helperFr: "Optionnel. À utiliser seulement si la clôture a besoin d’un titre.",
      })}

      {renderBilingualTextarea({
        label: "TEXTO DEL CIERRE",
        nameEs: "cierre_text",
        nameFr: "cierre_text_fr",
        placeholderEs: "Cierra con sobriedad, con dirección, sin exageración.",
        placeholderFr: "Conclue avec sobriété, direction et clarté.",
        rows: 6,
        idealEs: "Ideal: 300–700 caracteres.",
        idealFr: "Idéal : 300–700 caractères.",
      })}
    </div>
  );

  const renderCtaStep = () => (
    <div className="admNlSection">
      <div className="admNlSection-head">
        <h2>CTA bilingüe</h2>
        <p>
          El CTA debe pedir una sola acción clara. No debe presionar, prometer de
          más ni distraer de la idea central.
        </p>
      </div>

      <LanguageHeader />

      {renderBilingualTextarea({
        label: "MENSAJE DEL CTA",
        nameEs: "practica",
        nameFr: "practica_fr",
        placeholderEs:
          "Ej: Si esta edición te ayudó a mirar tu vida con más claridad, puedes continuar tu recorrido dentro de ZEDRO Academy.",
        placeholderFr:
          "Ex. Si cette édition t’a aidé à regarder ta vie avec plus de clarté, tu peux poursuivre ton parcours avec ZEDRO Academy.",
        rows: 4,
        idealEs: "Ideal: 180–420 caracteres. Una invitación sobria y directa.",
        idealFr: "Idéal : 180–420 caractères. Une invitation sobre et directe.",
      })}

      {renderBilingualInput({
        label: "TEXTO DE LA ACCIÓN",
        nameEs: "step4",
        nameFr: "step4_fr",
        placeholderEs: "Ej: Conocer ZEDRO Academy",
        placeholderFr: "Ex. Découvrir ZEDRO Academy",
        helperEs: "Debe expresar una sola acción clara.",
        helperFr: "Doit exprimer une seule action claire.",
      })}
    </div>
  );

  const renderReviewStep = () => {
    const developmentReady = hasContent(
      form.bloque1_title,
      form.bloque1_p1,
      form.bloque1_p2,
      form.callout_title,
      form.callout_text,
      form.step1,
      form.step2,
      form.step3
    );

    const developmentFrReady = hasContent(
      form.bloque1_title_fr,
      form.bloque1_p1_fr,
      form.bloque1_p2_fr,
      form.callout_title_fr,
      form.callout_text_fr,
      form.step1_fr,
      form.step2_fr,
      form.step3_fr
    );

    const ctaReady = hasContent(form.practica, form.step4);
    const ctaFrReady = hasContent(form.practica_fr, form.step4_fr);

    return (
      <div className="admNlSection meta">
        <div className="admNlSection-head">
          <h2>Revisión final</h2>
          <p>
            Revisa la vista previa completa antes de guardar o publicar la edición.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gap: 12,
            fontSize: 13,
            color: "rgba(44,59,81,.72)",
          }}
        >
          <div>
            <strong>Título ES:</strong>{" "}
            {form.hero_title?.trim() || "Falta título principal"}
          </div>

          <div>
            <strong>Título FR:</strong>{" "}
            {form.hero_title_fr?.trim() || "Pendiente"}
          </div>

          <div>
            <strong>Línea ES:</strong>{" "}
            {form.issue_line?.trim() || "Falta línea de edición"}
          </div>

          <div>
            <strong>Línea FR:</strong>{" "}
            {form.issue_line_fr?.trim() || "Pendiente"}
          </div>

          <div>
            <strong>Estado:</strong>{" "}
            {mode === "new" ? "Borrador" : getStatusLabel(form.status || "draft")}
          </div>

          <div>
            <strong>Imagen de portada:</strong>{" "}
            {form.hero_image?.trim() ? "Agregada" : "No agregada"}
          </div>

          <div>
            <strong>Apertura ES / FR:</strong>{" "}
            {form.lead?.trim() ? "ES agregada" : "ES pendiente"} ·{" "}
            {form.lead_fr?.trim() ? "FR agregada" : "FR pendiente"}
          </div>

          <div>
            <strong>Idea central ES / FR:</strong>{" "}
            {form.idea_central?.trim() ? "ES agregada" : "ES pendiente"} ·{" "}
            {form.idea_central_fr?.trim() ? "FR agregada" : "FR pendiente"}
          </div>

          <div>
            <strong>Desarrollo ES / FR:</strong>{" "}
            {developmentReady ? "ES agregado" : "ES pendiente"} ·{" "}
            {developmentFrReady ? "FR agregado" : "FR pendiente"}
          </div>

          <div>
            <strong>Notas de ZEDRO ES / FR:</strong>{" "}
            {form.callout_body?.trim() ? "ES agregadas" : "ES no agregadas"} ·{" "}
            {form.callout_body_fr?.trim() ? "FR agregadas" : "FR no agregadas"}
          </div>

          <div>
            <strong>CTA ES / FR:</strong>{" "}
            {ctaReady ? "ES agregado" : "ES pendiente"} ·{" "}
            {ctaFrReady ? "FR agregado" : "FR pendiente"}
          </div>

          <div>
            <strong>Versión francesa pública:</strong>{" "}
            {form.slug_fr?.trim() && form.hero_title_fr?.trim()
              ? "Preparada"
              : "Pendiente"}
          </div>
        </div>

        {validationError && (
          <p className="admNlHint warn" style={{ marginTop: 16 }}>
            {validationError}
          </p>
        )}

        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
            marginTop: 18,
          }}
        >
          <button
            type="button"
            className={"admNl-btn primary " + (savedPulse ? "pulse" : "")}
            onClick={save}
            disabled={saving || !!validationError}
          >
            {saving ? "Guardando…" : "Guardar edición"}
          </button>

        </div>

      </div>
    );
  };

  const renderActiveStep = () => {
    switch (currentStep.id) {
      case "identidad":
        return renderIdentityStep();
      case "portada":
        return renderCoverStep();
      case "apertura":
        return renderOpeningStep();
      case "idea":
        return renderIdeaStep();
      case "desarrollo":
        return renderDevelopmentStep();
      case "notas":
        return renderNotesStep();
      case "cierre":
        return renderClosingStep();
      case "cta":
        return renderCtaStep();
      case "revision":
        return renderReviewStep();
      default:
        return renderIdentityStep();
    }
  };

  if (loading) {
    return (
      <>
        <AdminHeader />

        <main className="admNlEdit">
          <header className="admNl-header">
            <h1>Cargando edición…</h1>
          </header>
        </main>
      </>
    );
  }

  return (
    <>
      <AdminHeader />
      <style>{MOBILE_EDITORIAL_STYLES}</style>

      <main className="admNlEdit">
        <header className="admNl-header">
          <div className="admNlHeader-left">
            <h1 style={{ margin: 0 }}>{title}</h1>

            <div className="admNlHeader-sub">
              <span className="admNlStatusPill">
                {mode === "new" ? "Borrador nuevo" : "Edición existente"}
              </span>

              <span className={"admNlSaveState " + (isDirty ? "dirty" : "clean")}>
                {isDirty ? "Cambios sin guardar" : "Todo guardado"}
              </span>

              {validationError ? (
                <span className="admNlHint warn">{validationError}</span>
              ) : (
                <span className="admNlHint">
                  Trabaja cada bloque en español y francés. La vista previa muestra
                  la versión en español.
                </span>
              )}
            </div>
          </div>

          <div className="admNlHeader-actions">
            <button
              type="button"
              className="admNl-btn"
              onClick={() => navigate("/admin/produccion/editorial")}
              disabled={saving}
            >
              Volver
            </button>

            <button
              type="button"
              className={"admNl-btn primary " + (savedPulse ? "pulse" : "")}
              onClick={save}
              disabled={saving || !!validationError}
              title={validationError || "Guardar edición"}
            >
              {saving ? "Guardando…" : "Guardar"}
            </button>
          </div>
        </header>

        <div className="admNlEdit-grid flagship">
          <section className="admNlEdit-form flagship">
            {renderStepNavigation()}

            {renderActiveStep()}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 10,
                marginTop: 2,
              }}
            >
              <button
                type="button"
                className="admNl-btn ghost"
                onClick={goBack}
                disabled={activeStep === 0}
              >
                Anterior
              </button>

              {!isLastStep ? (
                <button
                  type="button"
                  className="admNl-btn primary"
                  onClick={goNext}
                >
                  Siguiente
                </button>
              ) : (
                <button
                  type="button"
                  className="admNl-btn"
                  onClick={() => setActiveStep(0)}
                >
                  Volver al inicio
                </button>
              )}
            </div>
          </section>

          <section className="admNlEdit-preview flagship">
            <div className="admNlPreviewHeader">
              <h3 style={{ margin: 0 }}>Vista previa de la edición</h3>

              <button
                type="button"
                className="admNl-btn ghost"
                onClick={() => setPreviewOpen(true)}
              >
                Ver grande
              </button>
            </div>

            <div className="admNlPreviewFrame">
              <EditorialPreview data={form} />
            </div>

            <div
              style={{
                marginTop: 10,
                fontSize: 12,
                color: "rgba(44,59,81,.58)",
                textAlign: "center",
              }}
            >
              Usa el botón “Ver grande” para abrir una revisión ampliada.
            </div>
          </section>
        </div>

        {previewOpen && (
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Vista previa ampliada"
            onClick={() => setPreviewOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 3000,
              background: "rgba(8,22,34,.64)",
              padding: 20,
              display: "grid",
              placeItems: "center",
            }}
          >
            <div
              onClick={(event) => event.stopPropagation()}
              style={{
                width: "min(1040px, 100%)",
                maxHeight: "90vh",
                overflow: "auto",
                borderRadius: 24,
                background: "#f8fafc",
                boxShadow: "0 30px 100px rgba(0,0,0,.32)",
                border: "1px solid rgba(204,174,73,.24)",
              }}
            >
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  padding: "14px 16px",
                  background: "rgba(248,250,252,.94)",
                  backdropFilter: "blur(10px)",
                  borderBottom: "1px solid rgba(44,59,81,.10)",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 900,
                      color: "#0f2f46",
                    }}
                  >
                    Vista previa ampliada
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "rgba(44,59,81,.58)",
                    }}
                  >
                    Revisión visual de la edición antes de publicar.
                  </div>
                </div>

                <button
                  type="button"
                  className="admNl-btn ghost"
                  onClick={() => setPreviewOpen(false)}
                >
                  Cerrar
                </button>
              </div>

              <div style={{ padding: 18 }}>
                <EditorialPreview data={form} />
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}